/** base URL for non-root sites */
export const baseSite = new URL(process.env.PUBLIC_URL || '/', window.location.protocol + '//' + window.location.host).href;
/**
 * Gets the base site to support non-root sites and merges it
 * with other arbitrary URL's
 *
 */
export const getSite = (path) => combineURLs(baseSite, path);
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param baseURL The base URL
 * @param relativeURL The relative URL
 * @returns The combined URL
 */
const combineURLs = (baseURL, relativeURL) => {
    return relativeURL
        ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
        : baseURL;
};
